import { render, staticRenderFns } from "./toapplyTheListDeta.vue?vue&type=template&id=42076bb4&scoped=true&"
import script from "./toapplyTheListDeta.vue?vue&type=script&lang=js&"
export * from "./toapplyTheListDeta.vue?vue&type=script&lang=js&"
import style0 from "./toapplyTheListDeta.vue?vue&type=style&index=0&id=42076bb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42076bb4",
  null
  
)

export default component.exports